ready = ->
  return unless continueIfAllowed('ui_nodes', ['history']) || continueIfAllowed('people', ['technician_app_history'])

  technicianAppLogsTable = $('#technician_app_logs').dataTable
    sPaginationType: "full_numbers"
    bJQueryUI: true
    bProcessing: true
    bServerSide: true
    searching: false
    iDisplayLength: 50
    sAjaxSource: $('#technician_app_logs').data('source')
    order: [ [ 0, "desc" ] ]
    bAutoWidth: false
    fixedColumns: true
    aoColumnDefs:
      [{ 'bSortable': false, 'aTargets': nonSortableColumns() }]
    columns: widthStyle()


$(document).ready(ready)

nonSortableColumns = ->
  if $('table[data-ui="ui_node"]').length > 0
    [9]
  else
    [8]

widthStyle = ->
  if $('table[data-ui="ui_node"]').length > 0
    [
      { "width": "5%"}
      { "width": "15%"}
      { "width": "14%"}
      { "width": "15%"}
      { "width": "8%"}
      { "width": "12%"}
      { "width": "16%"}
      { "width": "6%"}
      { "width": "20%"}
      { "width": "8%"}
    ]
  else
    [
      { "width": "6%"}
      { "width": "15%"}
      { "width": "20%"}
      { "width": "8%"}
      { "width": "12%"}
      { "width": "20%"}
      { "width": "10%"}
      { "width": "30%"}
      { "width": "8%"}
    ]

